import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

const getElasticities = (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "elasticities"),
  };

  return athenaClient(config);
};

export const getElasticitiesByCycle = (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "elasticities_by_cycle"),
  };

  return athenaClient(config);
};

export default getElasticities;
